export const mainMenuFeatureTranslationJP = {
  MainMenuFeature: {
    todo_list: 'TODOリスト',
  },
};
